<div class="study-viewer">
  <div class="study-viewer__papaya" #studyViewerPapaya>
    <app-dashboard-study-papaya></app-dashboard-study-papaya>
  </div>

  @if (isPapayaRendered()){
    <div class="study-viewer__viewer-controls">
      <app-dashboard-study-viewer-controls></app-dashboard-study-viewer-controls>
    </div>
  }
</div>
